<template>
  <section class="page-container">
    <div>
      <h1>Renewal</h1>
    </div>
    <div class="header">
      <el-tabs
        v-model="active"
        @tab-click="changeTab">
        <el-tab-pane
          v-for="(tab, index) in tabList"
          :key="index"
          :label="tab.label"
          :name="tab.name"
        ></el-tab-pane>
      </el-tabs>
      <v-button
        v-if="active != 'quote'"
        :disabled="date == ''"
        class="export-btn"
        @click="handleExport">Export Excel</v-button>
    </div>

    <div class="search">
      <v-input
        v-model="filter.search"
        :prefixIcon="'el-icon-search'"
        :placeholder="active != 'renew'? 'Policy No., Cover Note No., HCID, Endorsement No., Customer Name, Contact, Referrer, VRD' : 'ID,Customer Name,Contact,Referrer Name,Price'"
        @keyEnter="filterData" />
    </div>
    <div class="filter-card">
      <div class="filter">
        <div class="filter-left">
          <div class="form-item">
            <span v-if="active == 'renew'">Expected Effective Date</span>
            <span v-else>End Date</span>
            <v-date-picker
              v-model="date"
              type="daterange"
              @change="filterData" />
          </div>
        </div>
        <div class="filter-middler">
          <div class="form-item">
            <span>Insurer</span>
            <span>
              <v-select
                v-model="filter.company_id"
                :list="companyList"
                @change="filterData" />
            </span>
          </div>
        </div>
        <div class="filter-right">
          <div class="form-item">
            <span>Product Type</span>
            <span>
              <v-select
                v-model="filter.class_id"
                :list="classList"
                @change="filterData" />
            </span>
          </div>
        </div>
      </div>
    </div>
    <unquote-list
      v-if="active == 'unquote'"
      ref="unquote"
      :filterData="filter"></unquote-list>
    <quote-list
      v-if="active == 'quote'"
      ref="quote"
      :filterData="filter"></quote-list>
    <renew-list
      v-if="active == 'renew'"
      ref="renew"
      :filterData="filter"></renew-list>
  </section>
</template>

<script>
import UnquoteList from './components/unquote-list'
import QuoteList from './components/quote-list'
import RenewList from './components/renew-list'
import {mapActions,mapState} from 'vuex'
import MixinOptions from '@/mixins/options'

export default {
  name: 'Policy',
  components:{
    UnquoteList,
    QuoteList,
    RenewList
  },
  mixins: [MixinOptions],
  data() {
    return{
      active: 'unquote',
      tabList:[
        {
          name: 'unquote',
          label: 'Unquoted Policies'
        },
        {
          name: 'quote',
          label: 'Quoted Policies'
        },
        {
          name: 'renew',
          label: 'Renew Quotes'
        },
      ],
      date: '',
      filter:{
        search: '',
        start_dt: '',
        end_dt: '',
        company_id: 0,
        class_id: 0,
      }
    }
  },
  computed:{
    ...mapState('renewal',['activeTab', 'getfilterData']),
    ...mapState('common',['specialOptions']),
    companyList(){
      let list = JSON.parse(JSON.stringify(this.insurerAllOptions))
      list.unshift({id: 0, name: 'All'})
      return list
    },
    classList(){
      let list =JSON.parse(JSON.stringify(this.specialOptions.renew_product_type))
      list.unshift({id: 0, name: 'All'})
      return list
    }
  },
  watch:{
    activeTab:{
      immediate: true,
      handler(val) {
        if(val){
          this.active =val
        }
      }
    },
    getfilterData:{
      immediate: true,
      deep: true,
      handler(val){
        if(val && Object.keys(val).length){
          this.filter = val
          if(val.start_dt && val.end_dt){
            this.date = []
            this.date.push(val.start_dt)
            this.date.push(val.end_dt)
          }
        }
      }
    }
  },
  beforeDestroy(){
    this.setFilterData(this.filter)
  },
  methods: {
    ...mapActions('renewal',['setActiveTab', 'setFilterData']),
    changeTab(){
      this.setActiveTab(this.active)
      this.clearFilter()
    },

    clearFilter(){
      this.date = []
      this.filter.start_dt = ''
      this.filter.end_dt = ''
      this.filter.company_id = 0
      this.filter.class_id = 0
      this.filter.search = ''
    },

    filterData(){
      if(this.date && this.date.length > 0){
        this.filter.start_dt = this.date[0]
        this.filter.end_dt = this.date[1]
      }else{
        this.filter.start_dt = null
        this.filter.end_dt = null
      }
      this.$refs[this.active].pageConfig.currentPage = 1
      this.$refs[this.active].network().getRenewalList()
    },

    handleExport(){
      this.$refs[this.active].network().getRenewalList({
        is_export: 1
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.header{
  position: relative;
  .export-btn{
    position: absolute;
    right: 0;
    top: 0;
  }
}
.search {
  font-weight: 600;
  margin-bottom: 20px;
}
.filter-card{
  margin-bottom: 15px;
  background: white;
  border: 1px solid #E1E4E8;
  border-radius: 5px;
  .filter {
    display: flex;
    padding: 0 15px;
    background: white;
    border-radius: 5px;
    .filter-left, .filter-middler, .filter-right {
      padding: 15px 0;
      width: 200px;
    }
    .filter-left {
      padding-right: 10px;
      width: 300px;
    }
    .filter-middler {
      padding: 15px 10px;
    }
    .filter-right {
      padding-left: 10px;
    }
  }
}
</style>
